import { useEffect, useState } from "react";
import { createPortal } from "react-dom";

// Import inhouse icons
import { X } from "@/components/icons_new";

const EXPORT_PRESETS = [
  { id: "current", label: "Current page" },
  { id: "all", label: "All orders" },
  // TODO: Show the number of selected orders
  { id: "selected", label: "Selected orders only" },
  // TODO: Show the number of searched orders.
  { id: "search", label: "Orders matching your search" },
  // TODO: Implement date range selection
  { id: "date", label: "Date range" },
];

const EXPORT_FORMATS = [
  { id: "excelCsv", label: "CSV for Excel, Numbers, or other spreadsheet programs" },
  { id: "plainCsv", label: "Plain CSV file" },
];

export default function OrdersExportModal({ isOpen, onClose, onExport }) {
  const [portalEl, setPortalEl] = useState(null);
  const [selectedPreset, setSelectedPreset] = useState("current");
  const [selectedFormat, setSelectedFormat] = useState("csv");

  useEffect(() => {
    if (!isOpen) return;

    const node = document.createElement("div");
    setPortalEl(node);
    document.body.appendChild(node);

    const handleEsc = (e) => {
      if (e.key === "Escape") onClose?.();
    };

    document.addEventListener("keydown", handleEsc);
    return () => {
      document.removeEventListener("keydown", handleEsc);
      document.body.removeChild(node);
      setPortalEl(null);
    };
  }, [isOpen, onClose]);

  if (!isOpen || !portalEl) return null;

  return createPortal(
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-[#000]/40"
      onClick={onClose}
    >
      <div
        className="w-full max-w-lg rounded-lg bg-white overflow-hidden shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex items-center justify-between bg-[#ececec] px-6 py-4">
          <span className="font-medium text-[#333333]">Export orders</span>
          <button onClick={onClose} aria-label="Close modal">
            <X className="h-5 w-5 text-[#333333]" />
          </button>
        </div>

        <div className="px-6 py-5 flex flex-col gap-5">
          {/* Export Section */}
          <section className="space-y-3">
            <h3 className="text-sm font-medium text-[#333333] tracking-wide">Export</h3>
            <div className="space-y-2">
              {EXPORT_PRESETS.map((preset) => (
                <label
                  key={preset.id}
                  className="flex items-center gap-3 rounded-lg px-4 font-medium text-sm text-[#333333] cursor-pointer"
                >
                  <input
                    type="radio"
                    name="export-scope"
                    className="accent-[#000]"
                    checked={selectedPreset === preset.id}
                    onChange={() => setSelectedPreset(preset.id)}
                  />
                  {preset.label}
                </label>
              ))}
            </div>
          </section>

          {/* Export as section */}
          <section className="space-y-3">
            <h3 className="text-sm font-medium text-[#333333]">Export as</h3>
            <div className="space-y-2">
              {EXPORT_FORMATS.map((format) => (
                <label
                  key={format.id}
                  className="flex items-center gap-3 rounded-lg px-4 font-medium text-sm text-[#333333] cursor-pointer"
                >
                  <input
                    type="radio"
                    name="export-format"
                    className="accent-[#000]"
                    checked={selectedFormat === format.id}
                    onChange={() => setSelectedFormat(format.id)}
                  />
                  {format.label}
                </label>
              ))}
            </div>
          </section>
        </div>

        {/* Footer */}
        <div className="flex justify-end gap-2 border-t border-[#d2d2d2] px-6 py-4">
          <button
            onClick={onClose}
            className="rounded-[10px] border border-[#b6b6b6] px-4 py-2 text-sm font-medium text-[#333] hover:bg-[#f5f5f5]"
          >
            Cancel
          </button>

          <button
            onClick={() => {
              onExport?.({ preset: selectedPreset, format: selectedFormat });
              onClose?.();
            }}
            className="rounded-[10px] bg-[#000] px-5 py-2 text-sm font-semibold text-white hover:bg-[#383838]"
          >
            Export orders
          </button>
        </div>
      </div>
    </div>,
    portalEl
  );
}